<template>
	<div class="ui-empty-state">
		<div class="ui-empty-state__icon ui-layout ui-alignment-center">
			<i :class="icon" />
		</div>
		<div class="ui-empty-state__label ui-layout ui-alignment-center ui-headline">
			<div>{{ label }}</div>
		</div>
		<div class="ui-empty-state__description ui-layout ui-alignment-center ui-headline-body-1">
			<div>{{ description }}</div>
		</div>
		<slot class="ui-layout ui-alignment-center" />
	</div>
</template>

<script>

export default {
	name: "EmptyState",
	props: {
		description: {
			type: String,
			default: "",
			required: false
		},
		icon: {
			type: String,
			default: "fas fa-empty-set",
			required: false
		},
		label: {
			type: String,
			default: "",
			required: false
		}
	}
};
</script>

<style lang="scss" scoped>
.ui-empty-state {
	.ui-empty-state__icon {
		margin: 32px 0;
		i {
			font-size: 160px;
		}
	}
	.ui-empty-state__label {
		margin: 16px 0;
	}
	.ui-empty-state__description {
		margin: 16px 0;
	}
}
</style>
